import Vue from 'vue';
import moment from 'moment';
import DxDateBox from 'devextreme-vue/date-box';
import { DxTextBox, DxCheckBox, DxNumberBox } from 'devextreme-vue';

export default {
  name: 'Installment',
  components: {
    DxTextBox,
    DxCheckBox,
    DxNumberBox,
    DxDateBox,
  },
  props: ['dataObj'],
  data: function () {
    return {
      installment: {
        instNo: 0,
        chargeDate: new Date(),
        amount: 0,
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.installment = this.dataObj;
      });
    },
  },
}

